export const AppConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  url: process.env.REACT_APP_API_ENDPOINT,
  org_code: process.env.REACT_APP_ORG_CODE,
  project_id: process.env.REACT_APP_PROJECT_ID,
};
